interface DatadogRum {
  addAction(name: string, context?: Record<string, unknown>): void;
}

declare global {
  interface Window {
    DD_RUM?: DatadogRum;
  }
}

export function datadogGuard(instance: DatadogRum): void {
  try {
    Object.defineProperty(window, "DD_RUM", {
      configurable: true,
      enumerable: true,
      get: () => instance,
      set: (attempted) => {
        // eslint-disable-next-line no-console
        console.warn(
          "[DD_RUM guard] blocked window.DD_RUM reassignment",
          attempted,
        );
        // facade enrichEvent attributes this to the offending MFE via event.service
        instance.addAction("dd-rum-reassignment-blocked");
      },
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.error("[DD_RUM guard] failed to install", error);
  }
}
